import React from 'react';
import { Skeleton } from '@hqo/react-components-library/dist/atoms/skeleton';

import { CanvasViewport, SkeletonFrame } from './styles';

/**
 * Placeholder while the plan loads.
 *
 * A skeleton rather than a spinner: the map fills the viewport, so a small centred spinner reads as
 * a stalled screen, while a block the shape of the plan shows where it is about to appear. It sits
 * in the same viewport the map uses, so nothing shifts when the image arrives.
 */
export const FloorplanMapSkeleton = (): JSX.Element => (
  <CanvasViewport data-testid="floorplan-map-skeleton">
    <SkeletonFrame>
      <Skeleton width="100%" height="100%" borderRadius="12px" variant="image" />
    </SkeletonFrame>
  </CanvasViewport>
);
